import { type Provider } from '@angular/core';

import { provideSvgIcon } from '@shared/ui/svg-icon';

export function provideSvgSprite(): Provider[] {
  return [provideSvgIcon({ spriteUrl: 'assets/images/icons/sprite.svg' })];
}
